import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

const { Content } = Layout;

export const EmptyLayout: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ padding: '20px' }}>
        {/* Здесь будет отображаться контент на основе текущего маршрута */}
        <Outlet />
      </Content>
    </Layout>
  );
};
